import { render, staticRenderFns } from "./GotoAuthorize.vue?vue&type=template&id=15827dfe&scoped=true"
import script from "./GotoAuthorize.vue?vue&type=script&lang=js"
export * from "./GotoAuthorize.vue?vue&type=script&lang=js"
import style0 from "./GotoAuthorize.vue?vue&type=style&index=0&id=15827dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15827dfe",
  null
  
)

export default component.exports